import { render } from "./EarningPointsModal.vue?vue&type=template&id=7656476d"
import script from "./EarningPointsModal.vue?vue&type=script&lang=js"
export * from "./EarningPointsModal.vue?vue&type=script&lang=js"

import "./EarningPointsModal.vue?vue&type=style&index=0&id=7656476d&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__